import { render } from "./Troli.vue?vue&type=template&id=05c902c6"
import script from "./Troli.vue?vue&type=script&lang=js"
export * from "./Troli.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__